export default {
  cn: {
    ibCommissionRuleSetting: {
      currentIB: '当前代理',
      levelIB: '级代理',
      notExist: '不存在',
      rule: '规则',
      product: '产品',
      ALL: '全部',
      toOriginalAccount: '分配給原始账号',
      toTargetAccount: '分配给指定账号',
      ruleIdGroup: ['按佣金','自定金额',],
      spreadCommission: '加点',
      externalCommission: '外佣',
      internalCommission: '内返',
      addRule: '添加规则',
      remove: '删除',
      percentage: '百分比',
      extrapercentage: '额外百分比',
      maxlevel: '分层最高金额',
      maxlevel2: '分层最高金额',
      fixamount: '固定金额',
      maxdiff: '与最高内返相差',
      percentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 分 配 ，總 設 定 不 超 過 100 % 。',
      extrapercentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 計 算 ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
      maxlevel_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
      maxlevel2_desc: '按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
      fixamount_desc: '按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
      maxdiff_desc: '按 即 月 交 易 量 達 到 的 內 返 條 件 , 與 最 高 內 返 條 件 的 相 差 來 分 配 佣 金  。相 差 的 金 額 以 輸 入 的 上 限 由 下 到 上 來 分 配 。'
    }
  },
  hk: {
    ibCommissionRuleSetting: {
      currentIB: '當前代理',
      levelIB: '級代理',
      notExist: '不存在',
      rule: '規則',
      product: '產品',
      ALL: '全部',
      toOriginalAccount: '分配給原始賬號',
      toTargetAccount: '分配給指定賬號',
      ruleIdGroup: ['按佣金','自定金額',],
      spreadCommission: '加點',
      externalCommission: '外佣',
      internalCommission: '內返',
      addRule: '添加規則',
      remove: '刪除',
      percentage: '百分比',
      extrapercentage: '額外百分比',
      maxlevel: '分層最高金額',
      maxlevel2: '分層最高金額',
      fixamount: '固定金額',
      maxdiff: '與最高內返相差',
      percentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 分 配 ，總 設 定 不 超 過 100 % 。',
      extrapercentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 計 算 ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
      maxlevel_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
      maxlevel2_desc: '按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
      fixamount_desc: '按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
      maxdiff_desc: '按 即 月 交 易 量 達 到 的 內 返 條 件 , 與 最 高 內 返 條 件 的 相 差 來 分 配 佣 金  。相 差 的 金 額 以 輸 入 的 上 限 由 下 到 上 來 分 配 。'
    }
  },
  en: {
    ibCommissionRuleSetting: {
      currentIB: 'Current IB',
      levelIB: 'Level IB',
      notExist: 'Not Exist',
      rule: 'Rule',
      product: 'Product',
      ALL: 'ALL',
      toOriginalAccount: 'To Original Account',
      toTargetAccount: 'To Target Account',
      ruleIdGroup: ['Gist Commission','Customize Money',],
      spreadCommission: 'Spread Commission',
      externalCommission: 'External Commission',
      internalCommission: 'Internal Commission',
      addRule: 'Add Rule',
      remove: 'Remove',
      percentage: 'Percentage',
      extrapercentage: 'Extrapercentage',
      maxlevel: 'Maxlevel',
      maxlevel2: 'Maxlevel',
      fixamount: 'Fixamount',
      maxdiff: 'Maxdiff',
      percentage_desc: 'percentage_desc',
      extrapercentage_desc: 'extrapercentage_desc',
      maxlevel_desc: 'maxlevel_desc',
      maxlevel2_desc: 'maxlevel2_desc',
      fixamount_desc: 'fixamount_desc',
      maxdiff_desc: 'maxdiff_desc'
    }
  }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/IB/ibCommissionRuleSetting.js